module.exports = __webpack_public_path__ + "files/589fde6b9ad7d44d7d727b5d5f701180.png";